import React, { useState } from "react"
import DataTable from "../../../../../components/atoms/table/DataTable.atom"
import Column from "../../../../../components/atoms/table/Column.atom"
import { getUniqueDatesFromWeeklyReport } from "../../../../../utils/report.utils"
import FooterGroup from "./FooterGroup.controller"
import WeekHoursDataTable from "./WeekHoursDataTable.controller"
import listDetailsIcon from "../../../../../design/assests/images/icons/list_details.svg"
import Modal from "../../../../../components/atoms/Modal.atom"
import ClientProjectChip from "../../../../../components/molecules/ClientProjectChip.molecule"
import useReportFiltersContext from "../../../../../hooks/contextConsumers/useReportFiltersContext.hook"
import { AIKALaunchDate } from "../../../../../consts/general.consts"
import IndividualReportLink from "../../../../../routers/Navigation/IndividualReportLink"
import { UNIFIEDDATE_VALUES } from "../../../../../consts/CompoundRangeDatePicker"
import Tooltip from "../../../../../components/atoms/Tooltip.atom"
import useScreenDimensionsContext from "../../../../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { BREAKPOINTS } from "../../../../../consts/responsiveBreakpoints.consts"

function TimeDifferenceModal({ modalData, onClose, isOpen }) {
  if (!modalData) return null
  const { timeDifferences, total } = modalData
  const groupedHeaderTimeDifferences = timeDifferences.map((el) => ({
    ...el,
    key: el.client + el.project,
  }))

  return (
    <Modal
      visible={isOpen}
      draggable={false}
      setVisible={onClose}
      onHide={onClose}
      scrollable
      scrollHeight="flex"
      header={
        <div className="flex gap-3">
          <img style={{ width: 32 }} src={listDetailsIcon} alt="Detalles" />
          <div className="flex flex-column">
            <div className="text-3xl font-semibold font-cairo line-height-1">
              Detalles de horas perdonadas
            </div>

            <p style={{ fontSize: 14, fontWeight: 400 }} className="mt-2">
              Integrante: {modalData?.fullName}
            </p>
          </div>
        </div>
      }
      className="consumo-semanal-report-hours-details-modal w-full"
      contentClassName="flex"
      dismissableMask
    >
      <div className="w-full flex-1 overflow-auto">
        <DataTable
          scrollable
          scrollHeight="flex"
          value={groupedHeaderTimeDifferences}
          rowGroupMode="subheader"
          groupRowsBy="key"
          sortField="key"
          sortOrder={1}
          rowGroupHeaderTemplate={(data) => {
            const total = groupedHeaderTimeDifferences.reduce((acc, el) => {
              if (el.key === data.key) {
                return acc + parseFloat(el.time)
              }
              return acc
            }, 0)
            return (
              <div className="flex justify-content-between align-items-center w-full">
                <ClientProjectChip
                  clientCode={data.client}
                  projectCode={data.project}
                />
                <div style={{ maxWidth: "8ch", width: "100%", paddingLeft: 7 }}>
                  <strong>
                    {Number.isInteger(total) ? total : total.toFixed(2)}
                  </strong>
                </div>
              </div>
            )
          }}
        >
          <Column
            header="Tarea"
            footer="Totales"
            style={{ maxWidth: "12ch" }}
            body={(node) => {
              return (
                <>
                  <Tooltip target={`#task-${node.taskId}`} position="bottom" />
                  <IndividualReportLink
                    data-pr-tooltip={node.taskName}
                    id={`task-${node.taskId}`}
                    className="redirect-link"
                    state={{
                      teamMemberId: +node.teamMemberId,
                      startDate: node.taskDate?.split("T")[0],
                      endDate: node.taskDate?.split("T")[0],
                      taskId: +node.taskId,
                      period: UNIFIEDDATE_VALUES.SINGLEDAY,
                    }}
                  >
                    {node.teamMemberCode}-{node.taskId}
                  </IndividualReportLink>
                </>
              )
            }}
          />
          <Column field="comment" header="Motivo" />
          <Column
            style={{ maxWidth: "8ch" }}
            field="time"
            footer={total}
            header="Horas"
          />
        </DataTable>
      </div>
    </Modal>
  )
}

const WeekHoursReportBody = React.forwardRef(
  (
    {
      reportData,
      holidays,
      schemaRules,
      teamMemberFilters,
      recalculateFooter,
      filteredUsers,
    },
    ref
  ) => {
    const [horizontalScrollCursor, setHorizontalScrollCursor] = useState(0)
    const [modalData, setModalData] = useState(null)
    const [isTimeDiffDetailsModalOpen, setIsTimeDiffDetailsModalOpen] =
      useState(false)

    const { screenWidth } = useScreenDimensionsContext()
    const isOnMobile = screenWidth <= BREAKPOINTS.MOBILE_BREAKPOINT

    const { weekHoursDateRange } = useReportFiltersContext()
    const isDateBeforeAIKALaunch = weekHoursDateRange[1] < AIKALaunchDate
    const uniqueDatesFromWeeklyReport = getUniqueDatesFromWeeklyReport(
      reportData.teamMemberReport
    )
    const allMembersLength = reportData?.teamMemberReport?.length

    const WEEK_SIZE = uniqueDatesFromWeeklyReport?.length
    const WEEK_DATES = uniqueDatesFromWeeklyReport

    return (
      <>
        <TimeDifferenceModal
          modalData={modalData}
          onClose={() => setIsTimeDiffDetailsModalOpen(false)}
          isOpen={isTimeDiffDetailsModalOpen}
        />

        <WeekHoursDataTable
          ref={ref}
          value={reportData.teamMemberReport}
          footerColumnGroup={FooterGroup(
            WEEK_SIZE,
            reportData,
            recalculateFooter,
            filteredUsers,
            horizontalScrollCursor
          )}
          responsiveLayout="scroll"
          sortMode="multiple"
          removableSort
          className="week-hours-report-data-table"
          scrollable
          scrollHeight="100%"
          onRowClick={(e) => {
            const target = e.originalEvent.target
            const clickedOnTeamMemberName =
              target.querySelector(".team-member-name")

            if (clickedOnTeamMemberName && isOnMobile) {
              console.log(e.data)
            }
          }}
          data={{
            WEEK_DATES,
            setModalData,
            setIsTimeDiffDetailsModalOpen: () =>
              setIsTimeDiffDetailsModalOpen(true),
            filteredUsers,
            allMembersLength,
            isDateBeforeAIKALaunch,
            holidays,
            schemaRules,
            teamMemberFilters,
            horizontalScrollCursor,
            setHorizontalScrollCursor,
          }}
        />
      </>
    )
  }
)

export default WeekHoursReportBody
